/* eslint-disable array-bracket-newline */
import { ITopWalletsResponseItem } from '@kattana-io/common';

interface IDecimals {
  base: number;
  quote: number;
}

interface ICurrencies {
  base: string;
  quote: string;
}

export enum ETableTimeframe {
  DAY = 'Day',
  WEEK = 'Week',
  MONTH = 'Month',
  LATEST = 'Latest',
}

enum TradesTab {
  CEXOrdersOpen = 'Open Orders',
  CEXOrdersHistory = 'Order History',
  Trades = 'Trades',
  Positions = 'My Trades',
  TopTraders = 'Top traders',
  PriceAlerts = 'Price alerts',
  LimitOrders = 'Limit orders',
  None = 'None',
}

const openOrders = {
  name: TradesTab.CEXOrdersOpen,
  icon: 'icon-list-close',
};

const historyOrders = {
  name: TradesTab.CEXOrdersHistory,
  icon: 'icon-report',
};

const trades = {
  name: TradesTab.Trades,
  icon: 'icon-swap',
};

const positions = {
  name: TradesTab.Positions,
  icon: 'icon-book',
};

const topTraders = {
  name: TradesTab.TopTraders,
  icon: 'icon-gem',
};

const priceAlerts = {
  name: TradesTab.PriceAlerts,
  icon: 'icon-alarm-checked-alt',
};

const limitOrders = {
  name: TradesTab.LimitOrders,
  icon: 'icon-cart',
};

const CEX_TABS = [openOrders, historyOrders, priceAlerts, limitOrders];

const DEX_TABS = [trades, positions, topTraders, priceAlerts, limitOrders];

const getVolume = (
  rowData: ITopWalletsResponseItem,
  rates: any,
  decimals: IDecimals,
  currencies: ICurrencies,
  flipped: boolean
) => {
  const ratesQuote = !flipped
    ? rates[currencies.quote]
    : rates[currencies.base];
  const ratesBase = !flipped ? rates[currencies.base] : rates[currencies.quote];
  if (ratesQuote) {
    return (
      (!flipped
        ? rowData.token1_volume / 10 ** decimals.quote
        : rowData.token1_volume / 10 ** decimals.base) * ratesQuote
    );
  }
  if (ratesBase) {
    return (
      (!flipped
        ? rowData.token0_volume / 10 ** decimals.base
        : rowData.token0_volume / 10 ** decimals.quote) * ratesBase
    );
  }
  return '-';
};

// parse ui timeframe to match the api one
const parseTableTimeframe = (
  timeframe: ETableTimeframe
): 'day' | 'week' | 'month' | 'latest' => {
  switch (timeframe) {
  case ETableTimeframe.MONTH:
    return 'month';
  case ETableTimeframe.WEEK:
    return 'week';
  case ETableTimeframe.LATEST:
    return 'latest';
  default:
    return 'day';
  }
};

export { getVolume, parseTableTimeframe, TradesTab, CEX_TABS, DEX_TABS };
